import {Resource} from 'i18next';
import languages from '../languages';
import * as ResourcesLocales0 from './clients/form.json'; import * as ResourcesLocales1 from './commons/common.json'; import * as ResourcesLocales2 from './dashboard/index.json'; import * as ResourcesLocales3 from './filepond/filepond.json'; import * as ResourcesLocales4 from './invoice/invoice.json'; import * as ResourcesLocales5 from './login/form.json'; import * as ResourcesLocales6 from './menu/menu.json'; import * as ResourcesLocales7 from './muidatatbles/datatables.json'; import * as ResourcesLocales8 from './payments/payments.json'; import * as ResourcesLocales9 from './PoC/simpleform.json'; import * as ResourcesLocales10 from './products/form.json'; import * as ResourcesLocales11 from './register/form.json'; import * as ResourcesLocales12 from './register/stepFour.json'; import * as ResourcesLocales13 from './register/stepOne.json'; import * as ResourcesLocales14 from './register/stepThree.json'; import * as ResourcesLocales15 from './register/stepTwo.json'; import * as ResourcesLocales16 from './user/cfdibg.json'; import * as ResourcesLocales17 from './user/contact.json'; import * as ResourcesLocales18 from './user/logo.json'; import * as ResourcesLocales19 from './user/series.json'; import * as ResourcesLocales20 from './validations/yup.json'; let ResourcesLocales = [ResourcesLocales0, ResourcesLocales1, ResourcesLocales2, ResourcesLocales3, ResourcesLocales4, ResourcesLocales5, ResourcesLocales6, ResourcesLocales7, ResourcesLocales8, ResourcesLocales9, ResourcesLocales10, ResourcesLocales11, ResourcesLocales12, ResourcesLocales13, ResourcesLocales14, ResourcesLocales15, ResourcesLocales16, ResourcesLocales17, ResourcesLocales18, ResourcesLocales19, ResourcesLocales20];

interface IResource {
	[key: string]: Resource;
}

interface INamespace {
	[key: string]: any;
}

let appLocales: IResource = {};
ResourcesLocales.map((module: any) => {

	const namespace: INamespace = {};
	namespace[`${module.namespace}`] = {...module.default};
	//console.log(namespace);

	appLocales = {...appLocales, ...namespace};

	return;
});

export const langs = Object.keys(languages);

const resources: Resource = {};

Object.keys(languages).map((lang) => {
	Object.keys(appLocales).map((fileName) => {
		resources[lang] = {
			translation: {
				...(resources[lang]?.translation as object),
				[fileName]: appLocales[fileName][lang],
			},
		};
	});
});

//console.log('resources', resources);

export default resources;
